import config from '@/config/index';
import { LogicContext } from '@/logic/main/types';
import { divideGameListToSlides } from '@/logic/main/utils';
import { BINGO_GAMES_ID } from '@/model/constants';
import { getLocale } from '@/utils';

export const prepareBingoGamesContent = async (context: LogicContext) => {
  const { bingoGames = [], controllersData, user } = context;
  const gameDetailsInfo = config.features.gameDetails.mode === 'enabled';

  if (!controllersData || !controllersData.bingoGames) {
    return { updates: [] };
  }

  const { components } = controllersData.bingoGames;

  const isBingoGamesVisible = bingoGames.length > 0;

  const updates = components.map(([id, cmp]) => {
    const {
      title,
      description,
      play_bingo_button,
      staticTexts,
      bingoStaticTexts,
    } = cmp.properties;

    const category = {
      id: BINGO_GAMES_ID,
      view_all_button_visible: false,
      title,
      description,
      games: bingoGames,
      gameDetailsInfo,
      staticTexts: {
        ...staticTexts,
        bingoTimer: {
          starting: bingoStaticTexts?.timer?.starting,
          closed: bingoStaticTexts?.timer?.closed,
        },
      },
      type: 'Extended Single Block',
      component_type: 'game_grid',
      slides: divideGameListToSlides({
        gameList: bingoGames,
        slideType: 'Extended Single Block',
      }),
    };

    return {
      type: 'setLayoutProperty',
      data: {
        path: `components.${id}.properties`,
        value: {
          category: isBingoGamesVisible ? category : undefined,
          animation: false,
          visible: isBingoGamesVisible,
          playButtonLabel: play_bingo_button.label,
          playButtonLabelVisible: play_bingo_button.visible && user.loggedIn,
          locale: getLocale(config),
          jurisdiction: config.jurisdiction,
        },
      },
    };
  });

  return { updates };
};
